module.exports = __webpack_public_path__ + "img/imgYLSYB(12).ac7dcbfb.png";